import { ReactNode } from 'react';

import { Box, CircularProgress } from '@material-ui/core';
import { Virtualizer, VirtualItem } from '@tanstack/react-virtual';

import EmptyState from './EmptyState';

interface VirtualizedListContainerProps {
  virtualizer: Virtualizer<HTMLUListElement, Element>;
  virtualItems: VirtualItem[];
  children: ReactNode;
  loading?: boolean;
  empty?: {
    title?: string;
    description?: string;
    icon?: ReactNode;
  };
  /**
   * Quando `true` (padrão), envolve os filhos em um Box com `position: absolute`
   * e `translateY` baseado no primeiro item visível — necessário para listas que
   * não posicionam cada item individualmente.
   *
   * Passe `false` quando cada item já tiver seu próprio `translateY` (ex: NewMessagesContainer),
   * evitando offset duplo.
   */
  positionItems?: boolean;
}

export default function VirtualizedListContainer({
  virtualizer,
  virtualItems,
  children,
  loading,
  empty,
  positionItems = true,
}: VirtualizedListContainerProps) {
  return (
    <>
      <Box
        style={{
          height: virtualizer.getTotalSize(),
          width: '100%',
          position: 'relative',
        }}
      >
        {positionItems ? (
          <Box
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              transform: `translateY(${virtualItems[0]?.start ?? 0}px)`,
            }}
          >
            {children}
          </Box>
        ) : (
          children
        )}
      </Box>

      {loading && (
        <Box textAlign="center">
          <CircularProgress color="inherit" size={24} />
        </Box>
      )}

      {!loading && empty && virtualItems.length === 0 && (
        <EmptyState
          icon={empty?.icon}
          title={empty?.title}
          description={empty?.description}
        />
      )}
    </>
  );
}
